<template>
    <div class="page flex flex-col md:border-l md:border-r">
         <TopBarBg
            :headerText="lbl.privacymenu.copydata.title"
            small
            :canGoBack="true"
        ></TopBarBg>
        <PageContent
            class="flex-auto px-6"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="55"
            :paddingTop="0">
            <div class="mt-9" v-if="Objprofile">
                <div>
                    <div class="text-blue-1 text-base">{{lbl.privacymenu.copydata.name}}</div>
                    <div class="mt-1">{{Objprofile.firstName}}</div>
                </div>
                <div class="mt-5">
                    <div class="text-blue-1 text-base">{{lbl.privacymenu.copydata.lastname}}</div>
                    <div class="mt-1">{{Objprofile.lastName}}</div>
                </div>
                <div class="mt-5">
                    <div class="text-blue-1 text-base">{{lbl.privacymenu.copydata.birthdate}}</div>
                    <div class="mt-1">{{ formatDate(Objprofile.birthDate) }}</div>
                </div>
                <div class="mt-5">
                    <div class="text-blue-1 text-base">{{lbl.privacymenu.copydata.phone}}</div>
                    <div class="mt-1">{{ contactNumberFormat }}</div>
                </div>
                <div class="mt-5">
                    <div class="text-blue-1 text-base">{{lbl.privacymenu.copydata.age}}</div>
                    <div class="mt-1">{{lbl.privacymenu.copydata.age_detail}}</div>
                </div>
                <div class="mt-5">
                    <!-- <div class="text-blue-1 text-base">{{lbl.privacymenu.copydata.email_label}}<span class="text-red-1 pl-1">*</span></div> -->
                    <InputEmail
                        :isDisable="true"
                        v-model:inputValue="Objprofile.email"
                        :isShowRequire="true"
                        :inputLbl="lbl.privacymenu.copydata.email"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errInfo[0]"
                        :isShowErrorLbl="true"
                        :trim="true"
                    ></InputEmail>
                </div>
                <div class="mt-5">
                    <div class="text-blue-1 text-base">{{lbl.privacymenu.copydata.password_label}}</div>
                    <div class="relative mt-5">
                        <label for="input-otp">
                            <div class="grid grid-cols-6 gap-2 text-center">
                                <div class="border border-blue-1 py-1 h-14 w-11 text-lg rounded-10px flex justify-center items-center">
                                    {{inputPassword[0]}}
                                </div>
                                <div class="border border-blue-1 py-1 h-14 w-11 text-lg rounded-10px flex justify-center items-center">
                                    {{inputPassword[1]}}
                                </div>
                                <div class="border border-blue-1 py-1 h-14 w-11 text-lg rounded-10px flex justify-center items-center">
                                    {{inputPassword[2]}}
                                </div>
                                <div class="border border-blue-1 py-1 h-14 w-11 text-lg rounded-10px flex justify-center items-center">
                                    {{inputPassword[3]}}
                                </div>
                            </div>
                        </label>
                        <input type="tel" id="input-otp" maxlength="4" v-model="inputPassword">
                    </div>
                </div>
            </div>
        </PageContent>
        <div class="px-6 pb-8 mt-10">
            <VBtn @click="clickExportProfile()"
                blocked
                large
                :variant="checkDisableBtn">
                {{ lbl.default.confirm }}
            </VBtn>
        </div>
        <div class="flyout-zone">
            <VBottomSheet v-model="bottomSheetConfirm" :persistent="false">
                <div class="px-10 -mt-10 text-center relative">
                    <div class="absolute right-5 top-14">
                        <img class="h-4 w-auto" @click="clickClose()" src="../../../assets/icon/dialog/close.svg" />
                    </div>
                    <div class="pt-12">
                        <div class="text-lg text-primary uppercase mt-5 mb-8" v-html="lbl.privacymenu.copydata.confirm_export"></div>
                    </div>
                    <VBtn class="mb-8" @click="clickConfirmExportProfile()"
                        blocked
                        large
                        variant="primary">
                        {{ lbl.default.confirm }}
                    </VBtn>
                </div>

                <Footer :hasPoweredBy="false" />
            </VBottomSheet>
            <VBottomSheet v-model="bottomSheetSuccess" :persistent="false">
            <div class="px-6 -mt-10 text-center relative">
                <div class="mb-4">
                    <img src="@/assets/icon/dialog/success.svg" class="w-20 h-20 mx-auto" alt />
                </div>
                <div class="absolute right-5 top-14">
                    <img class="h-4 w-auto" @click="clickClose()" src="../../../assets/icon/dialog/close.svg" />
                </div>
                <div>
                    <div class="text-lg text-primary uppercase mt-5" v-html="lbl.privacymenu.copydata.export_success_title"></div>
                    <div class="mt-6 mb-8 text-gray-secondary" v-html="lbl.privacymenu.copydata.export_success_detail"></div>
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>
        </div>
        <Footer :hasPoweredBy="false"></Footer>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>

import { FormHelper } from "@/helper/FormHelper"
//component
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
import InputEmail from "@/components/Input/label/InputEmail.vue";
import VBtn from "@/components/Button/VBtn.vue";
import Footer from "@/components/Layout/Footer/Footer.vue";
import VBottomSheet from "@/components/Dialog/BottomSheet.vue"

//mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin";

import DatetimeHelper from "@/helper/DatetimeHelper"
import Utility from '@/helper/Utility'
import BzbsProfile from '@/core/Account/service/BzbsProfile';

export default {
    name: "CopyData",
    mixins: [ModalMixin, AuthPageMixin, LocaleMixin, ErrorApiMixin],
    components: {
        TopBarBg,
        PageContent,
        InputEmail,
        VBtn,
        Footer,
        VBottomSheet,
    },
    data: function () {
        return {

            hasPoweredBy: false,
            errInfo: FormHelper.genErrorInfo(1),
            inputPassword: '',
            isFirstSave: true,
            strEmail: "",
            bottomSheetConfirm: false,
            bottomSheetSuccess: false,
        }
    },
    computed: {
        Objprofile: function() {
            if (this.profile == null) {
                return null;
            } else {
                return this.profile;
            }
        },
        contactNumberFormat:function() {
            let n1, n2, n3;
            n1 = this.profile.contactNumber.substr(2, 2);
            n2 = this.profile.contactNumber.substr(4, 3);
            n3 = this.profile.contactNumber.substr(7);
            return "0" + n1 + "-" + n2 + "-" + n3;
            // var tel = this.profile.contactNumber || ''
            // // tel = tel.substring(0, 7) + 'xxxx';
            // tel = tel.slice(0,-4) + 'xxxx'
            // return tel
        },
        checkDisableBtn: function() {
            if (!this.Objprofile) {
                return "disable";
            }
            if (!this.Objprofile.email || this.inputPassword.length < 4) {
                return "disable"
            }
            return "primary"
        },
    },
    methods: {
        formatDate: function (val) {
            if (Utility.isEmptyStr(val)) {
                return "-"
            } else {
                return DatetimeHelper.dateFullFormat(DatetimeHelper.unixTimestampToDate(val))
            }
        },
        clickExportProfile: function () {
            this.bottomSheetConfirm = true;
        },
        clickConfirmExportProfile: function () {
            this.bottomSheetConfirm = false;
            this.loadingModal.show();
            this.isFirstSave = false;
            let errs = FormHelper.filterError(this.errInfo);
            console.log(errs);
            var params = {
                email: this.Objprofile.email,
                pin: this.inputPassword,
            };
            return new Promise(() => {
                BzbsProfile.exportProfile(params).subscribe({
                    next: () => {
                        this.bottomSheetSuccess = true;
                        this.loadingModal.hide();
                    },
                    error: (err) => {
                        this.loadingModal.hide();
                        this.errorApi(err);
                    }
                })
            });
        },
        clickClose: function() {
            this.$router.back();
        },
    }

}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            width: 100%;
            max-width: 350px;
            padding: 16px;
        }
    }

    #input-otp {
        opacity: 0;
        position: absolute;
        left: -20000px;
    }
</style>
